module.exports = __webpack_public_path__ + "static/media/goc_about.1709db4d.jpg";